import React from 'react';
import ListItem from './ListItem';
import Container from './Container';
import { useSetActive, useSectionsList, useSubmitting } from '../../Contexts';

const SectionJumplist = () => {
  const sections = useSectionsList();
  const setActive = useSetActive();
  const submitting = useSubmitting();

  return (
    <Container>
      {sections.map(d => (
        <ListItem
          key={d.linkId}
          text={d.text || ''}
          linkId={d.linkId}
          active={d.active}
          enabled={d.enabled}
          complete={d.complete}
          disabled={submitting}
          onClick={() => setActive(d.linkId)}
        />
      ))}
    </Container>
  );
};

export default SectionJumplist;
